<app-widget-card-wrapper title="Presence—Banded kōkopu" [hide]="false">
  <div class="card-stretch">
    <img src="assets/wai-fish-graph.png" class="img-fluid" />
  </div>
  <div><small>2021</small></div>
</app-widget-card-wrapper>
